import React from 'react';

interface ContactPageProps {
  onBack: () => void;
}

export const ContactPage: React.FC<ContactPageProps> = ({ onBack }) => {
  const contacts = [
    { email: 'loveonreadai@gmail.com', label: 'General Inquiries' },
    { email: 'mactrixapp@gmail.com', label: 'Technical Support' }
  ];

  return (
    <div className="bg-slate-50 min-h-full font-sans flex flex-col">
      <nav className="bg-white border-b border-slate-100 px-6 py-4 sticky top-0 z-10 flex-none">
        <div className="max-w-md mx-auto flex items-center justify-between">
            <div className="flex items-center gap-2 cursor-pointer" onClick={onBack}>
                <img 
                    src="https://image2url.com/r2/default/images/1769369928623-3180bbac-a140-4e50-ac88-1cfcf218a72a.png" 
                    alt="LoveOnRead Logo" 
                    className="w-8 h-8 object-contain"
                />
                <span className="font-bold text-xl tracking-tight">
                    <span className="text-love">Love</span>
                    <span className="text-read">OnRead</span>
                </span>
            </div>
            <button 
                onClick={onBack}
                className="text-sm font-medium text-slate-600 hover:text-slate-900"
            >
                Back
            </button>
        </div>
      </nav>

      <main className="flex-1 w-full max-w-md mx-auto px-6 py-12 flex flex-col justify-center">
        <div className="text-center mb-10">
            <h1 className="text-3xl font-extrabold text-slate-900 mb-2">Contact Us</h1>
            <p className="text-slate-500">We'd love to hear from you.</p>
        </div>

        <div className="space-y-4">
            {contacts.map((contact) => (
                <a 
                    key={contact.email}
                    href={`mailto:${contact.email}`}
                    className="flex items-center p-5 bg-white rounded-2xl shadow-sm border border-slate-200 hover:border-brand-300 hover:shadow-md transition-all group"
                >
                    <div className="w-12 h-12 bg-brand-50 text-brand-600 rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                        </svg>
                    </div>
                    <div>
                        <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-0.5">{contact.label}</p>
                        <p className="text-slate-900 font-medium break-all">{contact.email}</p>
                    </div>
                    <div className="ml-auto text-slate-300 group-hover:text-brand-500 transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                        </svg>
                    </div>
                </a>
            ))}
        </div>

        <div className="mt-12 text-center">
            <p className="text-xs text-slate-400">
                Response time: Usually within 24 hours.
            </p>
        </div>
      </main>
    </div>
  );
};